// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer_disclaimer__2XX-V"};